module.exports = __webpack_public_path__ + "img/insta_logo_menu_m.5e98415d.png";